import { createPinia } from 'pinia'
import { definePreset } from '@primevue/themes'
import Aura from '@primevue/themes/aura'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip'
import { createApp } from 'vue'

import App from './App.vue'
import './assets/main.css'
import 'primeicons/primeicons.css'
import i18n from './libs/i18n'
import { registerValidationRules } from './libs/veeValidate'
import { createSentry } from './libs/sentry'
import router from './router'

const Noir = definePreset(Aura, {
    semantic: {
        primary: {
            50: 'var(--color-primary-50)',
            100: 'var(--color-primary-100)',
            200: 'var(--color-primary-200)',
            300: 'var(--color-primary-300)',
            400: 'var(--color-primary-400)',
            500: 'var(--color-primary-500)',
            600: 'var(--color-primary-600)',
            700: 'var(--color-primary-700)',
            800: 'var(--color-primary-800)',
            900: 'var(--color-primary-900)',
            950: 'var(--color-primary-950)',
        },
    },
})

registerValidationRules()

const app = createApp(App)

app.use(createPinia())
app.use(i18n)
app.use(ConfirmationService)
app.use(ToastService)
app.directive('tooltip', Tooltip)
app.use(PrimeVue, {
    theme: {
        preset: Noir,
        options: {
            cssLayer: { name: 'primevue', order: 'theme, base, primevue' },
            darkModeSelector: '.dark',
        },
    },
})

createSentry(app)
app.use(router)
app.mount('#app')
